export class CreatePay {
  bookingKey: number;
  amount: number;

  constructor(data: CreatePay) {
    this.bookingKey = data.bookingKey;
    this.amount = data.amount;
  }
}

export class CreatePaymentSystemPay {
  bookSessionBasket: BookSessionBasket;
  isFullPayment: boolean;

  constructor(bookSessionBasket: BookSessionBasket, isFullPayment: boolean) {
    this.bookSessionBasket = bookSessionBasket;
    this.isFullPayment = isFullPayment;
  }
}

export class BookSessionBasket {
  userKey: number;
  offerKeys: string[];
  bookedSessionWithPrice: BookedSessionWithPrice[];
  bookingAmount: number;
  phoneNumberUser: string;
  memoMessageUser: string;
  promoCodeDiscount?: number;
  promoCodeName?: string;

  constructor(data: BookSessionBasket) {
    this.userKey = data?.userKey || null;
    this.offerKeys = data?.offerKeys || null;
    this.bookedSessionWithPrice = data?.bookedSessionWithPrice || [];
    this.bookingAmount = data?.bookingAmount || null;
    this.phoneNumberUser = data?.phoneNumberUser || null;
  }

}

export class BookedSessionWithPrice {
  sessionBasketKey: number;
  sessionTotalPrice: number;

  constructor(sessionBasketKey: number, sessionTotalPrice: number) {
    this.sessionBasketKey = sessionBasketKey;
    this.sessionTotalPrice = sessionTotalPrice;
  }
}
